import { ItemContainer, ItemDate, ItemDateText, Item, ItemTime, ItemTimeInner, ItemTimeArrival, ItemAirport, ItemAirportLong, ItemAirportShort, ItemFlight, ItemFlightTime, ItemFlightTimeTotal, ItemFlightCarrier } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import ArrowLink from '../Link/ArrowLink.js';

var FlightDetailsItem = function FlightDetailsItem(_ref) {
  var flight = _ref.flight,
    homeBound = _ref.homeBound,
    date = _ref.date,
    texts = _ref.texts,
    onClick = _ref.onClick;
  if (!flight || !flight.departureName) {
    return false;
  }
  return /*#__PURE__*/jsxs(ItemContainer, {
    isHomeBound: homeBound,
    children: [/*#__PURE__*/jsx(ItemDate, {
      children: /*#__PURE__*/jsx(ItemDateText, {
        children: date
      })
    }), /*#__PURE__*/jsxs(Item, {
      children: [/*#__PURE__*/jsxs(ItemTime, {
        children: [/*#__PURE__*/jsxs(ItemTimeInner, {
          children: [flight && flight.departureDateTimeLocal.time || '', /*#__PURE__*/jsx(ItemTimeArrival, {
            children: flight && flight.arrivalDateTimeLocal.time || ''
          })]
        }), /*#__PURE__*/jsxs(ItemAirport, {
          children: [/*#__PURE__*/jsx(ItemAirportLong, {
            children: flight && flight.departureName || ''
          }), /*#__PURE__*/jsx(ItemAirportShort, {
            children: flight && flight.providerKeys && flight.providerKeys.DepartureCode || ''
          }), /*#__PURE__*/jsx(ItemAirportLong, {
            children: flight && flight.destinationName || ''
          }), /*#__PURE__*/jsx(ItemAirportShort, {
            children: flight && flight.providerKeys && flight.providerKeys.DestinationCode || ''
          })]
        })]
      }), /*#__PURE__*/jsxs(ItemFlight, {
        children: [/*#__PURE__*/jsxs(ItemFlightTime, {
          children: [/*#__PURE__*/jsx(ItemFlightTimeTotal, {
            children: flight && flight.flightTime && flight.flightTime.display || ''
          }), /*#__PURE__*/jsx(ArrowLink, {
            className: "flight-time-link",
            onClick: onClick,
            children: texts && texts.flightInfoButtonLabel || ''
          })]
        }), /*#__PURE__*/jsxs(ItemFlightCarrier, {
          children: [flight.carrierLogo && /*#__PURE__*/jsx("img", {
            src: flight && flight.carrierLogo || '',
            alt: flight && flight.carrierName || '',
            className: "carrier-logo"
          }), flight && flight.carrierName || '']
        })]
      })]
    })]
  });
};
FlightDetailsItem.defaultProps = {
  homeBound: false,
  onClick: null
};
var FlightDetailsItem$1 = FlightDetailsItem;

export { FlightDetailsItem$1 as default };
//# sourceMappingURL=FlightDetailsItem.js.map
